import PropTypes from 'prop-types';
import React, { Component } from 'react';
import config from 'config';

const ICONS = {
  BOG: {
    title: "BOG",
    path: "M42.593 45.305l-.626 1.6-.806 2.073-1.925-1.118-1.48-.863-.958 1.42-1.244 1.843-1.63-1.52-1.248-1.17-1.255 1.17-1.62 1.52-1.247-1.843-.956-1.42-1.482.863-1.92 1.118-.8-2.072-.65-1.6-.482.147V63.98l10.403-6.692 10.398 6.69V45.454l-.47-.148zM36.375 26.88c-.272-.237-.657-.45-1.155-.606-.5-.155-1.156-.248-1.963-.248h-2.954v5.243h2.81c1.4 0 2.415-.187 3.033-.59.62-.403.927-1.098.927-2.097 0-.285-.05-.577-.145-.887-.093-.308-.28-.58-.553-.817zm-1.568-5.077c.44-.142.793-.326 1.05-.564.264-.236.45-.502.557-.8.106-.296.16-.598.16-.907 0-.832-.276-1.452-.822-1.835-.546-.378-1.46-.585-2.744-.585h-2.705v4.893h2.81c.693 0 1.255-.06 1.694-.203zm18.344 2.51l2.38-2.55-2.89-1.95 1.758-3.012-3.252-1.26 1.05-3.33-3.46-.502.276-3.48-3.474.276-.507-3.455-3.328 1.044-1.264-3.252-3.01 1.757-1.955-2.894-2.547 2.382-2.544-2.382L28.43 4.6 25.407 2.84l-1.26 3.252-3.32-1.045-.51 3.454-3.475-.276.28 3.48-3.46.5 1.048 3.33-3.26 1.263 1.764 3.013-2.892 1.95 2.38 2.55-2.38 2.546 2.892 1.953-1.763 3.016 3.26 1.26-1.048 3.328 3.46.507-.28 3.475 3.477-.276.507 3.452 3.32-1.046 1.26 3.258 3.022-1.76 1.952 2.892 2.544-2.38 2.547 2.38 1.954-2.892 3.01 1.76 1.265-3.258 3.33 1.046.506-3.452 3.474.276-.277-3.475 3.46-.507-1.05-3.327 3.253-1.26-1.76-3.017 2.893-1.954-2.38-2.546zM40.69 34.2c-1.555 1.167-3.903 1.79-7.04 1.79H27.94c-.664 0-1.206-.114-1.62-.256-.417-.144-.737-.362-.966-.61-.224-.25-.407-.565-.492-.922-.083-.354-.154-.744-.154-1.15V15.575c0-.407.07-.786.154-1.142.085-.357.254-.658.478-.91.23-.248.556-.433.973-.577.417-.144.963-.204 1.627-.204h5.528c1.618 0 2.98.146 4.08.453 1.11.308 2.006.733 2.695 1.278.69.55 1.192 1.188 1.496 1.926.313.735.467 1.53.467 2.387 0 1.162-.32 2.178-.96 3.048-.644.868-1.536 1.527-2.676 1.977 1.616.502 2.763 1.222 3.443 2.16.675.938 1.014 2.012 1.014 3.177 0 2.185-.78 3.883-2.338 5.048z"
  },
  EXTRA_PLACES: {
    title: "Extra Places",
    path: "M53.652 1.28H10.998c-1.053 0-1.912.72-1.912 1.595v59.7c0 1.038.755 1.496 1.674.977l20.052-11.04c.92-.51 2.423-.505 3.34.01l19.89 11.032c.917.52 1.813.06 1.813-.977v-59.7c0-.877-1.15-1.594-2.203-1.594zm-8.595 26.3h-8.822v8.873h-7.818V27.58H19.59v-7.77h8.827v-8.823h7.818v8.822h8.822v7.77z"
  },
  MONEY_BACK: {
    title: "Moneyback",
    path: "M50.458 21.435l-19.192-.023 4.44-13.67L1.643 32.63l17.89 24.89 4.454-13.704 18.794.026 7.678-22.405zm2.602.005l-7.677 22.4 3.602.006 7.676-22.4-3.6-.005zm6.453.008l-7.675 22.4 3.83.008 7.675-22.398-3.83-.01z"
  },
  GENERIC_PROMO: {
    title: "Generic Promo",
    path: "M60.798 18.432H46.772c.98-.49 1.837-1.042 2.695-1.593 3-2.145 4.655-4.9 4.655-7.657 0-2.266-1.103-4.288-2.695-5.574-1.532-1.41-3.553-2.145-5.758-2.145-2.39 0-4.472.796-6.37 2.02-2.82 1.84-5.024 4.656-6.616 7.842l-.184.428c-.55-1.225-1.225-2.327-2.02-3.49-1.287-1.84-2.94-3.554-4.78-4.78-1.837-1.224-4.042-2.02-6.37-2.02-2.327 0-4.41.92-6.063 2.45-1.593 1.47-2.695 3.614-2.695 6.003 0 1.47.367 2.88 1.225 4.226 1.102 1.654 2.695 3.124 5.022 4.288H4.2c-1.652 0-3.06 1.41-3.06 3.124v11.27h29.584V18.432h3.614v14.394H63.86v-11.27c0-1.715-1.347-3.124-3.062-3.124zM6.713 63.82h24.01V37.05H6.714V63.82zm27.624 0h23.95V37.05h-23.95V63.82zM17.922 14.02c-1.225-.797-1.96-1.532-2.39-2.206-.366-.673-.55-1.286-.55-1.898 0-.92.49-2.022 1.286-2.757.858-.795 2.02-1.285 3-1.285 1.41 0 2.697.43 3.983 1.286 1.9 1.35 3.798 3.554 5.085 6.127.674 1.286 1.164 2.633 1.47 4.042-5.88-.613-9.74-1.96-11.883-3.308zm20.152-3.185C39.176 9.305 40.4 8.02 41.75 7.16c1.285-.856 2.633-1.285 3.858-1.285h.06c1.165 0 2.145.43 2.88 1.042.735.612 1.102 1.408 1.102 2.266 0 .98-.49 2.39-2.817 4.042-2.205 1.593-6.003 3.247-11.76 4.41.55-2.327 1.653-4.777 3-6.798z"
  },
  PRICE_BOOST: {
    title: "Priceboost",
    path: "M5.264 33.653H20.89l-6.287 18.19h23.44l6.228-18.19H59.9l-16.42-32.17-38.214 32.17zm5.25 30.34h23.44l1.22-3.603h-23.44l-1.22 3.602zm26.737-9.707H13.81l-1.1 3.418h23.442l1.1-3.418z"
  }
};

export default class PromoIcon extends Component {
  static propTypes = {
    type: PropTypes.string
  }

  render() {
    const {type} = this.props;

    const {
      [type]: {
        title,
        path
      } = ICONS.GENERIC_PROMO
    } = ICONS;

    if (!config.isProduction && !ICONS.hasOwnProperty(type)) {
      console.warn(`Invalid PromoIcon requested: "${type}", defaulted to "GENERIC_PROMO".`); // eslint-disable-line no-console
    }

    return (
      <svg className="promo-icon" viewBox="0 0 65 65" xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
        <path d={path}/>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/svg/PromoIcon.js